import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { SettingsProvider } from '@/contexts/SettingsContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { MobileCTA } from '@/components/layout/MobileCTA';
import { CookieBanner } from '@/components/layout/CookieBanner';
import HomePage from '@/pages/HomePage';
import ListingsPage from '@/pages/ListingsPage';
import VehicleDetailPage from '@/pages/VehicleDetailPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import LegalPage from '@/pages/LegalPage';
import PrivacyPage from '@/pages/PrivacyPage';
import CookiesPage from '@/pages/CookiesPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import '@/App.css';

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileCTA />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <SettingsProvider>
          <Routes>
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/coches" element={<PublicLayout><ListingsPage /></PublicLayout>} />
            <Route path="/coches/:id" element={<PublicLayout><VehicleDetailPage /></PublicLayout>} />
            <Route path="/nosotros" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/contacto" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/aviso-legal" element={<PublicLayout><LegalPage /></PublicLayout>} />
            <Route path="/politica-privacidad" element={<PublicLayout><PrivacyPage /></PublicLayout>} />
            <Route path="/politica-cookies" element={<PublicLayout><CookiesPage /></PublicLayout>} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
